import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { keyCodes } from '../../constants';
import Box from '../box';
import Stack from '../stack';
import Heading from '../heading';
import SelectedIcon from '../selected-icon';
import ActionGroup from './components/action-group';

const PresetContainer = ({
  title = '',
  isSelected = false,
  editLabel = '',
  deleteLabel = '',
  children,
  onClick,
  onEditClick = null,
  onDeleteClick = null,
}) => {
  const isInteractive = !isSelected;
  const classes = classNames('ws-ui-preset-container', {
    'ws-ui-preset-container--interactive': isInteractive,
    'ws-ui-preset-container--selected': isSelected,
  });

  const handleKeyDown = (e) => {
    if (e.keyCode === keyCodes.SPACE || e.keyCode === keyCodes.ENTER) {
      e.preventDefault();
      onClick();
    }
  };

  const interactiveProps = {
    role: 'button',
    tabIndex: '0',
    onKeyDown: handleKeyDown,
  };

  return (
    <div className={classes} onClick={onClick} {...(isInteractive && interactiveProps)}>
      <Box padding="spacing-xs" paddingTop="spacing-2-xs">
        <Stack gap="spacing-xs">
          {title && (
            <div className="ws-ui-preset-container__header">
              {isSelected && (
                <div className="ws-ui-preset-container__selected-icon">
                  <SelectedIcon />
                </div>
              )}
              <Heading type="heading-6" singleLine>
                {title}
              </Heading>
              <ActionGroup
                editLabel={editLabel}
                deleteLabel={deleteLabel}
                onEditClick={onEditClick}
                onDeleteClick={onDeleteClick}
              />
            </div>
          )}
          <div className="ws-ui-preset-container__content">{children}</div>
        </Stack>
      </Box>
    </div>
  );
};

PresetContainer.propTypes = {
  title: PropTypes.string,
  editLabel: PropTypes.string,
  deleteLabel: PropTypes.string,
  isSelected: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  onClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
};

export default PresetContainer;
